/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, object } from 'prop-types'
import { jsx, Input, Flex } from 'theme-ui'
import { useField } from 'formik'
import NumberFormat from 'react-number-format'
import './formInputs.css'

const PercentGroupItem = ({ answer, value, ...props }) => {
  const [field, meta, helpers] = useField({ ...props, name: answer.id })

  const { setValue, setError } = helpers

  const handleChange = e => {
    if (!e.target.value.length) {
      // removes this from the values object in submit handler
      setValue(undefined)
      return setError(true)
    }
    return setValue(e.target.value)
  }

  return (
    <Flex>
      <NumberFormat
        {...field}
        {...props}
        suffix="%"
        customInput={Input}
        value={value}
        onChange={handleChange}
        // values.value is string representation of value. we restrict character limit to 3 or less.
        isAllowed={values => values.value.length < 4}
        sx={{
          position: 'relative',
          top: 3,
          bg:
            meta.touched && meta.error
              ? 'inputError'
              : !meta.error && !props.disabled && meta.value
              ? 'inputSuccess'
              : props.disabled
              ? 'white'
              : 'inputBackground',
          color: props.disabled ? 'muted' : 'black',
          textAlign: 'center',
          width: '83px',
          height: '50px',
          mr: 3,
        }}
        data-automation-id={`percent-group-${answer.id}`}
      />
    </Flex>
  )
}

PercentGroupItem.propTypes = {
  answer: object,
  disabled: bool,
  value: string,
}

export default PercentGroupItem
